import { Component, Input, OnInit } from '@angular/core';
import { WebWidgetService } from '../web-widget/web-widget.service';

@Component({
  selector: 'cc-call-icon',
  templateUrl: './call-icon.component.html',
  styleUrls: ['./call-icon.component.scss']
})
export class CallIconComponent implements OnInit {
  @Input() number: string;

  constructor(public webWidgetService: WebWidgetService) {}

  ngOnInit() {}

  openClickToCallWidget(phoneNumber: string) {
    this.webWidgetService.openDialPadWithNumber(phoneNumber);
  }
}
